document.addEventListener("DOMContentLoaded", function() {
(function(){
if (document.querySelectorAll('.info_list_item-wrap .list_item').length) {
  document.querySelectorAll('.info_list_item-wrap .list_item').forEach(function (ele) {
    ele.addEventListener('click', handleEvent);
    ele.addEventListener('touchstart', handleEvent);
  });
}

function handleEvent(evt) {
  document.querySelectorAll('.info_list_item-wrap .list_item').forEach(function (item) {
    item.classList.remove('active');
  });
  evt.currentTarget.classList.add('active');
  var ScrollSection;
  var offsetDigit;
  if(window.innerWidth < 699){
    offsetDigit = 70
  }else{
    offsetDigit = 80
  }

  var ScrollSection;
  var dataIdToMatch = evt.target.getAttribute('data-slidehref');
  
  if(evt.target.innerHTML == 'Review'){
      var reviewElement = document.querySelector('[data-id="Review"]');
     if (reviewElement) {
       ScrollSection = reviewElement.offsetTop - offsetDigit;
     }
     else{
       ScrollSection = document.querySelector('body'); 
     }
  }
  else{
  var matchingElement = document.querySelector('[data-id="' + dataIdToMatch + '"]');
  if (matchingElement) {
    ScrollSection = matchingElement.offsetTop - offsetDigit;
  } else {
    ScrollSection = document.querySelector('body'); 
  }
  }
  window.scrollTo({
    top: ScrollSection,
    behavior: 'smooth',
  });
  }

})()

  function isInViewport(elem) {
    var elementTop = elem.offsetTop;
    var elementBottom = elementTop + elem.offsetHeight / 2;
    var viewportTop = window.scrollY;
    var viewportHalf = viewportTop + window.innerHeight / 2;
    return elementBottom > viewportTop && elementTop < viewportHalf;
  }

  function setActiveLink(getID) {
    var navBarLinks = document.querySelectorAll('.info_list_item-wrap ul li a');
    navBarLinks.forEach(function(link) {
      link.classList.remove('active');
    });
    var navBarItems = document.querySelectorAll('.info_list_item-wrap ul li');
    navBarItems.forEach(function(item) {
      item.classList.remove('active');
    });
    if(getID == 'Review'){
        var activeLink = document.querySelector('.info_list_item-wrap ul li a[data-slidehref="sticky_review"]');
    }
    else{
        var activeLink = document.querySelector('.info_list_item-wrap ul li a[data-slidehref="' + getID + '"]');
    }
    if (activeLink) {
      activeLink.classList.add('active');
      activeLink.parentElement.classList.add('active');
    }
  }
  function handleScroll() {
    var scenarioInnerElements = document.querySelectorAll('.scenario_inner');
    scenarioInnerElements.forEach(function(element) {
      if (isInViewport(element)) {
        var getID = element.getAttribute('data-id');
        
        setActiveLink(getID);
      }
    });
  }

  window.addEventListener('load', handleScroll);
  window.addEventListener('resize', handleScroll);
  window.addEventListener('scroll', handleScroll);

  var linkElements = document.querySelectorAll('.info_list_item-wrap ul li a');
  linkElements.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
    });
  });

})

window.addEventListener('scroll', function() {
  var stickySection = document.querySelector('.sticky-info-bar');
  var body = document.body;
  
  if (stickySection) {
    var offsetTop = stickySection.offsetTop;
    if (window.scrollY >= offsetTop) {
      if (!body.classList.contains('product_stickybar')) {
        body.classList.add('product_stickybar');
      }
    } else {
      body.classList.remove('product_stickybar');
    }
    if (window.scrollY === 0) {
      body.classList.remove('product_stickybar');
    }
  }
});

// product specifications viewall code starts here

var viewLessElements = document.querySelectorAll('#view_less');
viewLessElements.forEach(function(element) {
  element.style.display = 'none';
});


var viewAllElements = document.querySelectorAll('#view_all');
viewAllElements.forEach(function(viewAllElement) {
  viewAllElement.addEventListener('click', function() {
    var specificationTable = this.closest('.specification-table');
    var elements = specificationTable.querySelectorAll('.label-value-list.d-hide');

    elements.forEach(function(element) {
      element.style.display = 'block';
      element.classList.add('d-flex');
    });

    specificationTable.querySelector('#view_less').style.display = 'block';
    this.style.display = 'none';
  });
});


var viewLessElements = document.querySelectorAll('#view_less');
viewLessElements.forEach(function(viewLessElement) {
  viewLessElement.addEventListener('click', function() {
    var specificationTable = this.closest('.specification-table'); 
    var elements = specificationTable.querySelectorAll('.label-value-list.d-hide');

    elements.forEach(function(element) {
      element.style.display = 'none';
      element.classList.remove('d-flex');
    });

    specificationTable.querySelector('#view_all').style.display = 'block';
    this.style.display = 'none';
  });
});

// product specifications viewall code ends here


// 3D title effect code strats here

var lastScrollTop = 100;
var ProductSectionLink;

function setupListeners() {
  if (window.innerWidth > 767 && window.innerWidth <= 1300) {
    setTimeout(function () {
      ProductSectionLink = document.querySelector(".product-right .product-section__main .product-section__link");
      addListeners();
    }, 300);
  } else if (window.innerWidth < 768) {
    var DefaultProduct = document.querySelector(".product-section__main .product-section__link");
    if (DefaultProduct !== null) { 
      ProductSectionLink = DefaultProduct;
    } else {
      ProductSectionLink = document.querySelector(".product-middle .product-section__main .product-section__link");
    }
    addListeners();
  } else {
    ProductSectionLink = document.querySelector(".product-section__link");
    addListeners();
  }
}

function addListeners() {
  window.addEventListener("resize", setupListeners);
  observeProductSectionLink();
}

function observeProductSectionLink() {
  if (!ProductSectionLink) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        ProductSectionLink.classList.add("scrolled-class");
      } 
    });
  });

  observer.observe(ProductSectionLink);
}

setupListeners();

// Hide 3d button

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function () {

var button = document.querySelector(".shopify-model-viewer-ui__controls-overlay button");
 if (button) {
  button.click();
  }
    },300)


});

const galleryItems = document.querySelectorAll('.img-gallery__item-inner');
  const closeBtn = document.querySelector('.close');
  const bodyEle = document.querySelector('body');
  galleryItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
             e.preventDefault();
            const target = item.getAttribute('data-target');
            const modal = document.getElementById(target);
            
            if (modal.classList.contains('open')) {
                console.log('close');
                modal.classList.remove('open');
                bodyEle.classList.remove('modal-open');
            } else {
               console.log('open');
                document.querySelectorAll('.modal.open').forEach(function(openModal) {
                    openModal.classList.remove('open');
                    bodyEle.classList.remove('modal-open');
                });
            
                modal.classList.add('open');
                bodyEle.classList.add('modal-open');
            }
        });
    });

    document.querySelectorAll('.close').forEach(function(closeBtn) {
        closeBtn.addEventListener('click', function() {

            const modal = closeBtn.closest('.modal');
            modal.classList.remove('open');
            bodyEle.classList.remove('modal-open');
        });
    });

    window.addEventListener('resize', function (e) {
      checkScreenSize();
    });
  
    checkScreenSize();
  
    function checkScreenSize() {
      var newWindowWidth = window.innerWidth;
  
      if (newWindowWidth < 768) {
        var headings = document.querySelectorAll('.img-popup-section .section-heading-box');
  
        headings.forEach(function (heading) {
          heading.addEventListener('click', function () {
             var nextElement = this.nextElementSibling;
              if (nextElement) {
                  var displayStyle = getComputedStyle(nextElement).display;
                  nextElement.style.display = (displayStyle === 'none' || displayStyle === '') ? 'block' : 'none';
              }
            if (!this.classList.contains('open')) {
              this.classList.add('open');
            }
            else{
              this.classList.remove('open');
            }
          });
        });
      }
    }
